// extracted by mini-css-extract-plugin
export default {"container":"NextPiece_container__O1nbM","title":"NextPiece_title__F4Yti","grid":"NextPiece_grid__8IKyf"};